import React from 'react';
import { withTheme } from 'styled-components';
const CloseIcon = ({
  theme,
  width = '30px',
  height = '30px'
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, `
        .cls-close-1 {
          clip-path: url(#clip-Cancel);
        }
  
        .cls-close-2 {
          fill: ${theme?.global?.colors['brand']};
        }
  
        .cls-close-3 {
          fill: #fff;
        }
        `), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Cancel"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "20",
    height: "20"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Cancel",
    class: "cls-close-1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    class: "cls-close-2",
    cx: "8.5",
    cy: "8.5",
    r: "8.5",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cancel-2",
    "data-name": "Cancel",
    class: "cls-close-3",
    d: "M6.172,5.475,3.842,3.145,6.159.827A.484.484,0,0,0,5.475.142L3.157,2.46.839.142A.484.484,0,0,0,.154.827L2.472,3.145.141,5.475a.484.484,0,0,0,.685.685L3.157,3.829,5.487,6.16a.484.484,0,1,0,.685-.685Z",
    transform: "translate(7.343 7.349)"
  })));
};
export default withTheme(CloseIcon);